module.exports = __webpack_public_path__ + "files/4d3ab0d1222c359ba65d3c049475afd3.png";